<template>
  <div class="frame">
    <div class="frame__inner container">
      <div class="frame__header">
        <Back
          :title="catalogName"
          :redirect="redirect"
        />
      </div>
      <div
        class="frame__body"
      >
        <div class="service-list">
          <div class="service-list__inner">
            <div class="service-list__search">
              <ap-search
                v-model="searchText"
                :placeholder="t('services.search_placeholder')"
                @input="filter"
              />
            </div>
            <ap-loader
              v-if="loading"
              class="service-list__loader"
            />
            <div
              v-else 
              class="service-list__cards"
            >
              <div
                v-if="!catalogsServices.length"
                class="not-found"
              >
                Ничего не найдено
              </div>
              <div
                v-for="service in catalogsServices"
                v-else
                :key="service.id"
                class="sl-card"
              >
                <router-link
                  :to="{ name: 'service', 
                         params: { 
                           id: service.id, 
                           name: service.name, 
                           catalogName, 
                           catalogId: service.catalogs[0]
                         }}"
                >
                  <div class="sl-card__inner">
                    <div class="sl-card__icon">
                      <img
                        :src="service.icon ? service.icon : defaultServiceIcon  "
                        alt="icon "
                      >
                    </div>
                    <div class="sl-card__text">
                      {{ service.name }}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import apSearch from '@/components/UI/apSearch.vue';
import apLoader from '@/components/UI/apLoader.vue';

import Back from '@/components/Back.vue';

export default defineComponent({
  name: 'ServiceListView',
  components: {
    apSearch,
    apLoader,
    Back,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const { t } = useI18n();
    const catalogName = ref('');
    const serviceList  = ref<any[]>([]);
    const searchText = ref('');
    const loading = ref<boolean>(true);
    
    const defaultServiceIcon = require('@/assets/icons/defaultService.svg');
    const fromMain = computed(() => store.getters['services/fromMain']);
    const language = computed(() => store.getters['language']);
    
    const redirect = ref({
      name: fromMain.value ? 'main' : 'service-category',
      text: fromMain.value ? t('main'): t('pay_serivces')
    });
    
    
    const getServices = async () => {

      try {
        loading.value = true;


        const res = await store.dispatch('services/getServices');

        if (res) {
          const { catalogs, services } = res;
          
          const serviceTypeName = catalogs.filter((item) => item.id === +route.params.id);
          serviceList.value = services.filter((item) => item.catalogs[0] === +route.params.id);
          catalogName.value = serviceTypeName && serviceTypeName.length ? serviceTypeName[0].name : '';   
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        loading.value = false;
      }
    };

    const filter = (e: Event) => {
      const element = e.target as HTMLInputElement;
    	searchText.value = element.value;
      
      const validSearchText = searchText.value && searchText.value.replace(/\s/g, '').length > 0;
      const emptySearchText = searchText.value.length === 0;

      validSearchText && store.dispatch('services/getServices', 
        { 
          name: element.value ,
          language: language.value
        });
        
      emptySearchText && store.dispatch('services/getServices');

    };

    onBeforeMount(() => {
      getServices();
    });

    onBeforeUnmount(() => {
      if (!serviceList.value.length) {
        store.dispatch('services/getServices');
      }
    });

    return {
      redirect,
      filter,
      catalogsServices: serviceList,
      catalogName: catalogName,
      loading,
      searchText,
      defaultServiceIcon,
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.service-list{
  max-width: 460px;
  width: 100%;
  margin: 0 auto;
  padding: 54px 16px 82px 16px;
  &__search{
    margin-bottom: 40px;
  }
  &__loader{
    height: 300px;
  }
}
.sl-card{
  padding: 16px 10px 19px 10px;
  background: #F6F7F7;
  border-radius: 9px;
  margin-bottom: 8px;
  &:last-child{
    margin-bottom: 0;
  }
  &__inner{
    display: flex;
    align-items: center;
  }
  &__text{
    color: $primary-blue;
  }
  &__icon{
    margin-right: 8px;
    img{
      width: 100%;
      height: 100%;
      height: 32px;
      width: 32px;
      border-radius: 100%;
    }
  }
}
.tele2{
  .sl-card{
    &__title{
      color: $tele2-primary-black;
    }
  }
}
.altel{
  .sl-card{
    &__title{
      color: $altel-primary-black;
    }
  }
}
</style>